<template>
  <div>
    <v-layout 
      row
      @click="dialog = true"
      class="existing-entry"
    >
      
      <v-divider vertical class="ml-2 mr-1 mt-2 mb-2" style="border-width: 4.5px" :color="entry.client.Color"/>

      <v-flex shrink>
        <v-card-text class="pl-0 pr-0">
          <v-avatar
            slot="activator"
            size="30px"
            style="margin: 0px 5px 5px"
            class="elevation-3"
          >
            <img 
              style="backgroundColor: white"
              :src="entry.client.ImageUrl"/>
          </v-avatar>  
        </v-card-text>
      </v-flex>
      
      <v-flex grow pa-1>
        <v-card-text class="pl-0 pb-0 pt-2">
          <div class="caption">
            <b style="color: #F52C00">{{entry.HoursWorked}} Hours </b>
          </div>
          <div class="text-truncate activityName">
            <span class="font-weight-bold">{{entry.client.Name}}</span>
            ({{entry.project.Name}})
          </div>
          <div></div>
          <div class="category activityName text-truncate font-weight-thin">
            {{entry.activity.Name}}
          </div>
          <div class="text-truncate caption" v-if="entry.UserAccountId != entry.modify.id">
            Submitted by {{entry.modify.GivenName}}
          </div>
        </v-card-text>
      </v-flex>

      <v-flex shrink class="smallScreen">
      </v-flex>

      <v-flex shrink class="approvalStatus">
        <v-card-text v-if="entry.approval">
          <!-- {{entry.approval.Status}} -->
          <v-icon v-if="entry.approval.Status == 'approved'" color="#4BD37B">
            mdi-check-circle
          </v-icon>
          <v-icon color="#FF9600" v-else>
            mdi-clock
          </v-icon>
        </v-card-text>
      </v-flex>
    </v-layout>

    <v-divider> </v-divider>

    <!-- END ENTRY  -->
    
    <!-- DIALOG BOX WHEN CLICKED -->
    <v-dialog persistent v-model="dialog" max-width="600px">
      <widget-entryForm
        :formData="entry"
        :isNewEntry="false"
        @close="dialog = false"
        @delete="entryDeleted"
        @save="entrySaved"
        :submitEntryFor="submitEntryFor"
      >
      </widget-entryForm>
    </v-dialog>
    <v-snackbar
      v-model="notification"
      :top="true"
      :timeout="4000"
      color="success"
    >
      {{notificationText}}
      <v-btn
        flat
        @click="notification = false"
      >
        Close
      </v-btn>
      

    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment'

/* CONSIDER USING v-divider EXAMPLE FOR THIS*/

var colors = {
  "Rio": "red",
  "QLD Govt": "green",
  "Pipefish": "lightblue",
  "NA": "orange",
  "Tabcorp": "darkslategray",
  "Youi": "black"
}
export default {
  props: ['entry', 'submitEntryFor'],
  data: () => {
      return {
        dialog: false,
        notification: false,
        notificationText: "",
      }
  },
  created() {
    // console.log(this.entry);
  },
  computed: {
    style: function() {
      return {
        borderLeft: `solid 10px #${this.entry.client.Color}`
      }
    },
    highlightClasses: function() {
      return {
        "existing-entry": true,
        approvedHighlight: this.entry.approval ? this.entry.approval.Status == 'approved' : false,
        pendingApprovalHighlight: this.entry.approval ? this.entry.approval.Status != 'approved' : false,
        notApprovedHighlight: this.entry.approval ? false : true
      }
    }
  },
  methods: {
    entryDeleted() {
      this.dialog = false
      this.notificationText = "Timesheet entry deleted successfully"
      this.notification = true
      this.$emit('updateEntries')
    },
    entrySaved(text) {
      this.dialog = false
      this.notificationText = text
      this.notification = true
      this.$emit('updateEntries')
    }
  },
  // filters: {
  //   dateFormat(value) {
  //     var date = moment(value)
  //     return date.format('dddd, D MMMM')
  //   }
  // }
  
}
</script>

<style>
.displayHours {
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 15px;

  padding-top: 15px;
  border: 1px solid lightblue;
  border-radius: 10px;
  background-color: lightblue
}

.existing-entry:hover{
  /* opacity: 0.8; */
  cursor: pointer;
  background-color: #f9f9f9
}
.existing-entry:active {
  opacity: 0.5;
}

.activityName{
  font-size: 13px
}
/* 
.smallScreen{
  border: 1px solid red
} */

@media screen and (max-width: 700px) {
  .activityName {
    /* background-color: blue; */
    /* color: white; */
    width: 500px
  }
}

@media screen and (max-width: 600px) {
  .activityName {
    /* background-color: blue; */
    /* color: white; */
    width: 400px
  }
}



@media screen and (max-width: 500px) {
  .activityName {
    /* background-color: blue; */
    /* color: white; */
    width: 300px
  }
}

/* On screens that are 600px wide or less, the background color is olive */
/*//JD was here*/
@media screen and (max-width: 360px) {
  .activityName {
    /* background-color: olive; */
    /* color: white; */
    width: 200px
  }
}


</style>
